var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/PartnerConnection/PumpPartner/index.tsx";
import React, { useMemo, useState } from 'react';
import { Divider, HStack, IconInfo, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { useApiError, useLibrePartner, useToast } from 'Hooks';
import { InfoModal, Link, RichText } from 'Components/utility';
import { formatDate } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const PumpPartner = ({
  partnerConnection
}) => {
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [footerLoading, setFooterLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showToast
  } = useToast();
  const {
    showStopSharingModal
  } = useLibrePartner();
  const scopes = useMemo(() => [...new Set(partnerConnection.consent.scopes.reduce((acc, scope) => {
    const splittedScope = scope.split('.');
    if (splittedScope.length > 1) {
      acc.push(splittedScope[1]);
    }
    return acc;
  }, []))], [partnerConnection.consent.scopes]);
  const scopesStr = useMemo(() => {
    const scopeStrArr = scopes.map(key => i18n.t(`Global.microcopy.scopes.${key}`).toLowerCase());
    scopeStrArr[0] = scopeStrArr[0].split('')[0].toUpperCase() + scopeStrArr[0].slice(1);
    return scopeStrArr.join(', ');
  }, [scopes]);
  const scopesModal = useMemo(() => {
    return /*#__PURE__*/React.createElement(Stack, {
      gap: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 7
      }
    }, scopes.map(scope => {
      return /*#__PURE__*/React.createElement(Stack, {
        key: scope,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(Text, {
        testID: `ConnectedPumpPartner.scope.${scope}`,
        marginBottom: "$2",
        color: "$text.100",
        fontWeight: "$bodyBase.strong",
        fontSize: "$bodyBase.strong",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 15
        }
      }, `${i18n.t(`Connections.modals.dataSharingBottomSheet.${scope}Title`)}`), /*#__PURE__*/React.createElement(Stack, {
        marginLeft: "$3",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(RichText, {
        fontToken: "$bodySmall.default",
        testID: `ConnectedPumpPartner.scope.${scope}.description`,
        text: i18n.t(`Connections.modals.dataSharingBottomSheet.${scope}`),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 17
        }
      })));
    }));
  }, [scopes]);
  const onStopSharing = () => {
    showStopSharingModal(partnerConnection.partner.name, 'Global.modals.stopSharingPartner.title', 'Global.modals.stopSharingPartner.body', async () => {
      try {
        setFooterLoading(true);
        showToast({
          message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
          'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved')
        });
        mediator.publish('router:navigate', '/connections');
      } catch {
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    });
  };
  return /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedPumpPartner.subtitle",
    color: "$text.100",
    fontWeight: "$h4.strong",
    fontSize: "$h4.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 9
    }
  }, i18n.t('ConnectedPumpPartner.subtitle')), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedPumpPartner.bodyText",
    marginTop: "$2",
    color: "$text.100",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 9
    }
  }, i18n.t('ConnectedPumpPartner.content.connectedPumpPartnerTile.primaryText', {
    pumpPartner: partnerConnection.partner.name
  })), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedPumpPartner.scopes",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 11
    }
  }, scopesStr), /*#__PURE__*/React.createElement(Stack, {
    onPress: () => setShowModalInfo(true),
    cursor: "pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(IconInfo, {
    testID: "ConnectedPumpPartner.info-icon",
    size: "S",
    color: "$interactive.core.enabled",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedPumpPartner.connectedAt",
    marginTop: "$4",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 9
    }
  }, i18n.t('ConnectedPumpPartner.content.connectedPumpPartnerTile.secondaryText', {
    dateTime: formatDate(partnerConnection.consent.created)
  })), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 9
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(Link, {
    testID: "ConnectedPumpPartner.stopSharing-btn",
    onPress: onStopSharing,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 11
    }
  }, i18n.t('Global.modals.stopSharing.title')), /*#__PURE__*/React.createElement(InfoModal, {
    isOpen: showModalInfo,
    title: i18n.t('Connections.modals.dataSharingBottomSheet.title'),
    customBody: scopesModal,
    handleClose: () => setShowModalInfo(false),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175,
      columnNumber: 9
    }
  })));
};
export default PumpPartner;